const DigiLabsTels = {
    _country: undefined,
    _libphonenumber: undefined,
    _loadingDependencies: undefined,

    init: function () {
        this._dependencies().then(() => {
            document.querySelectorAll('input[type="tel"]:not(.--ignored)').forEach(node => {
                node.classList.add('--ignored');

                let countries = node.dataset.countries;
                new DigiLabsTelControl(this._libphonenumber, node, countries ? JSON.parse(countries) : undefined);
            });
        });
    },

    getCountry: function () {
        if (this._country === undefined) {
            this._country = (navigator.language || 'cs-CZ').split('-')[1] || 'CZ';
        }

        return this._country;
    },

    _dependencies: function () {
        if (this._libphonenumber) {
            return Promise.resolve();
        }

        if (this._loadingDependencies) {
            return this._loadingDependencies;
        }

        this._loadingDependencies = new Promise((resolve, reject) => {
            let scriptNode = document.createElement('script');
            scriptNode.src = 'https://cdn.jsdelivr.net/npm/libphonenumber-js/bundle/libphonenumber-js.min.js';
            scriptNode.async = true;
            scriptNode.onload = () => {
                if (window['libphonenumber'] !== undefined) {
                    this._libphonenumber = window['libphonenumber'];
                    resolve();
                }

                reject(new Error('❌ libphonenumber not available after load'));
            };
            scriptNode.onerror = () => reject(new Error('❌ Failed to load libphonenumber-js'));
            document.head.appendChild(scriptNode);
        });

        return this._loadingDependencies;
    }
};

DigiLabsTels.init();

document.addEventListener('LokiRequestEnd', function () {
    DigiLabsTels.init();
});

class DigiLabsTelControl {
    _library;

    _nodes = {
        wrapper: null,
        code: null,
        inner: null,
        tel: null,
        input: null,
    };

    _countries;
    _value = '';
    _wasFilled = false;
    _hasChanged = false;

    constructor(library, inputNode, countries) {
        this._library = library;

        // countries
        this._countries = {};
        (countries || this._library.getCountries()).forEach(country => {
            country = country.toUpperCase();

            this._countries[country] = '+' + this._library.getCountryCallingCode(country);
        });

        // value
        let sanitized = this._sanitize(inputNode.value);
        let value = this._library.parseNumber(sanitized);
        value.country = value.country ?? DigiLabsTels.getCountry();
        value.countryCallingCode = '+' + this._library.getCountryCallingCode(value.country);
        value.phone = value.phone ?? '';

        if (value.phone === '') {
            value.phone = sanitized.replace(value.countryCallingCode, '');
        }

        this._value = value.phone;
        this._wasFilled = this._value !== '';

        this._render(inputNode, value);
        this._validate(true);
    }

    _render(inputNode, value) {
        this._nodes.wrapper = document.createElement('div');
        this._nodes.wrapper.classList.add('c-digilabs-tel');

        this._nodes.code = document.createElement('select');

        let codes = [];
        for (const code of Object.values(this._countries)) {
            if (! codes.includes(code)) {
                codes.push(code);
            }
        }

        codes.sort().forEach(code => {
            let optionNode = document.createElement('option');
            optionNode.value = code;
            optionNode.innerText = code;
            optionNode.selected = code === value.countryCallingCode;

            this._nodes.code.appendChild(optionNode);
        });

        this._nodes.code.addEventListener('change', () => {
            let country = Object.keys(this._countries).find(key => this._countries[key] === this._nodes.code.value);
            localStorage.setItem('DigiLabsTels.country', country);

            this._validate();
        });

        this._nodes.inner = document.createElement('span');

        this._nodes.input = inputNode.cloneNode(true);
        this._nodes.input.className = '--ignored --ghost';
        this._nodes.input.placeholder = '';
        this._nodes.input.addEventListener('focus', () => {
            this._nodes.tel.focus();
        });

        this._nodes.tel = document.createElement('input');
        this._nodes.tel.type = 'tel';
        this._nodes.tel.classList.add('--ignored');
        this._nodes.tel.placeholder = inputNode.placeholder;
        this._nodes.tel.value = value.phone;
        this._nodes.tel.addEventListener('keydown', (event) => {
            let ctrlOrCmd = event.ctrlKey || event.metaKey;
            let allowedCombo = ctrlOrCmd && ['a', 'c', 'v', 'x'].includes(event.key.toLowerCase());
            let allowedKeys = [
                'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', 'Home', 'End'
            ];

            if (allowedCombo || allowedKeys.includes(event.key)) {
                return;
            }

            if (!/[0-9\s.\-()_]/.test(event.key)) {
                event.preventDefault();
            }
        });
        this._nodes.tel.addEventListener('paste', (event) => {
            let pasted = (event.clipboardData || window.clipboardData).getData('text');
            if (!/^[0-9\s.\-()_]+$/.test(pasted)) {
                event.preventDefault();
            }
        });
        this._nodes.tel.addEventListener('input', () => {
            if (this._value !== this._nodes.tel.value) {
                this._value = this._nodes.tel.value;
                this._hasChanged = true;
                this._validate();
            }
        });

        this._nodes.inner.appendChild(this._nodes.input);
        this._nodes.inner.appendChild(this._nodes.tel);

        this._nodes.wrapper.appendChild(this._nodes.code);
        this._nodes.wrapper.appendChild(this._nodes.inner);

        inputNode.replaceWith(this._nodes.wrapper);
    }

    _validate() {
        let value = this._nodes.tel.value;
        let phone = this._sanitize(this._nodes.code.value + value);

        this._wasFilled = this._wasFilled || value !== '';

        try {
            let isValid = this._library.isValidPhoneNumber(phone);
            if (isValid) {
                this._nodes.wrapper.classList.remove('invalid');
                if (this._hasChanged) {
                    this._nodes.wrapper.classList.add('valid');
                }
                this._nodes.input.value = phone;
            } else {
                this._nodes.wrapper.classList.remove('valid');

                if ((this._nodes.input.required && this._wasFilled) || value !== '') {
                    this._nodes.wrapper.classList.add('invalid');
                    this._nodes.input.value = '~invalid';
                } else {
                    this._nodes.wrapper.classList.remove('invalid');
                    this._nodes.input.value = '';
                }
            }
        } catch (error) {
            this._nodes.wrapper.classList.remove('valid');
            this._nodes.wrapper.classList.add('invalid');
            this._nodes.input.value = '~invalid';
        }
    }

    _sanitize(value) {
        return value
            .replace(/[^0-9+]/g, '')
            .replace(/(?!^)\+/g, '')
    }
}